<div class="search-box">
  <span class="material-icons search-icon">search</span>

  <input
    type="text"
    [placeholder]="placeholder"
    [ngModel]="valor"
    (ngModelChange)="onInput($event)"
  />

  
<!-- Botón "limpiar": solo aparece cuando hay texto escrito -->
  <button
    *ngIf="valor"
    type="button"
    class="btn-clear"
    (click)="limpiar()"
    aria-label="Limpiar búsqueda"
  >
    <span class="material-icons">close</span>
  </button>
</div>
